export {default as View} from './src/View';



// WEBPACK FOOTER //
// ./~/vega-view/index.js